import { baseQuery } from "src/store/helpers/baseQuery";
import { keepUnusedDataFor } from "src/store/helpers/cacheLifetime";

import { createApi } from "@reduxjs/toolkit/query/react";

import rtkClient from "./rtkClient";

export const downloadsApi = createApi({
    reducerPath: "downloadsApi",
    tagTypes: ["Releases"],
    keepUnusedDataFor,
    baseQuery,
    endpoints: (builder) => ({
        getReleases: rtkClient.getReleases(builder),
    }),
});

export const { useGetReleasesQuery, usePrefetch } = downloadsApi;
